
export const UInt8ToBlob = (...value: Uint8Array[]): Blob =>
    new Blob(value as BlobPart[])
